import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["validateOnly"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import patchCart from './patch-cart';
import createCart from './create-cart';
import isCartNotFoundError from "../utils/is-cart-not-found-error";

/**
 * NOTE - re: magic visitor id - sigh.
 * the below value is used for passing to a patch call to carts v2 in order to have
 * backend validate and fix the cart when we don't know how to fix it on the front-end.
 * We use it to create a validateOnly flag for the mergeCartsByParams function.
 * Originally implemented December 11th, 2018
 */
export var MAGIC_VISITOR_ID = '00000000-0000-0000-0000-000000000000';

/**
 * mergeCarts will delete the entire cart and should be used for clearing cart
 *
 * @param {object} params - named parameters
 * @param {boolean} params.validateOnly - whether to validate only

 * @returns {Promise} fetch promise
 */
var mergeCarts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var validateOnly, params, finalId, _t, _t2;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          validateOnly = _ref.validateOnly, params = _objectWithoutProperties(_ref, _excluded);
          if (!validateOnly) {
            _context.next = 1;
            break;
          }
          _t = MAGIC_VISITOR_ID;
          _context.next = 3;
          break;
        case 1:
          _context.next = 2;
          return window.webShellClient.identity.getVisitData();
        case 2:
          _t = _context.sent.visitorId;
        case 3:
          finalId = _t;
          _context.prev = 4;
          _context.next = 5;
          return patchCart(_objectSpread(_objectSpread({}, params), {}, {
            actions: [{
              op: 'merge',
              path: '/',
              value: {
                visitorId: finalId
              }
            }]
          }));
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
          _context.prev = 6;
          _t2 = _context["catch"](4);
          if (!isCartNotFoundError(_t2)) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", createCart());
        case 7:
          throw _t2;
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[4, 6]]);
  }));
  return function mergeCarts(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default mergeCarts;